import React from "react";
import hubspotLogo from "../../../../assets/integrations/image-133.png";

const IntegrationInfo = ({ aceStatus, onDisconnect, onConnectToAce }) => {
  return (
    <div className="hubspot-info-section">
      <div className="hubspot-info-header">
        <div className="hubspot-title-group">
          <div className="hubspot-logo-wrapper">
            <img src={hubspotLogo} alt="HubSpot" className="hubspot-logo" />
          </div>
          <h1 className="hubspot-title">HubSpot</h1>
          <button className="disconnect-button" onClick={onDisconnect}>
            Disconnect
          </button>
        </div>
        <div className="hubspot-info-content">
          <p className="hubspot-description">
            A unified CRM platform for marketing, sales, and CS.
          </p>
        </div>
      </div>
      <div className="hubspot-info-actions">
        {/* <div className="hubspot-expiry">
          <p className="hubspot-expiry-label">Connection Expires On</p>
          <p className="hubspot-expiry-date">22/03/20234</p>
        </div> */}

        <button className="connect-to-ace-button" onClick={onConnectToAce}>
          ACE Configuration
        </button>
      </div>
    </div>
  );
};

export default IntegrationInfo;
